var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about"}},[_c('div',{staticClass:"bioWrapper"},[_c('div',{staticClass:"bioImg left",style:({
						'background-image': 'url(' + _vm.leftImage.url + ')'
					})}),_c('div',{staticClass:"bioText"},[_c('h1',{staticClass:"header"},[_vm._v("about")]),_c('div',{staticClass:"mobileImg",style:({
						'background-image': 'url(' + _vm.customBackground.url + ')'
					})}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.bio)}})]),_c('div',{staticClass:"bioImg right",style:({
						'background-image': 'url(' + _vm.rightImage.url + ')'
					})})])])}
var staticRenderFns = []

export { render, staticRenderFns }